// Dev-only auth session — bypasses MSAL/Entra for local development.
// The stored token is sent as the Bearer token; DevAuthHandler on the backend
// accepts a User GUID and looks up the registered user in the DB.
// Never imported in production — always guard with import.meta.env.DEV.

const STORAGE_KEY = 'tdDevToken';

/** Store a userId GUID as the active dev session token. */
export function setDevToken(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
}

/** Returns the stored token, or null if none. */
export function getDevToken(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearDevToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
